import { Component, OnInit, inject } from '@angular/core';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { TegelModule } from '@scania/tegel-angular-17';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-main-content',
    templateUrl: './main-content.component.html',
    styleUrls: ['./main-content.component.scss'],
    standalone: true,
    imports: [TegelModule, RouterOutlet, AsyncPipe]
})
export class MainContentComponent {
  loadingService = inject(LoadingService);
}
